// extracted by mini-css-extract-plugin
module.exports = {"auth-wrapper":"_1rN10jYY","box":"jQKHoMSe","logo":"_2ezFs-US","auth-wrapper-header":"_1LQ7H48O"};